import * as React from 'react'
// libs
import styled from 'styled-components'
// hooks
import useModalData from 'hooks/useShowModal'
// components
import HeaderOrigin from 'components/UI/Modal/Header'
import { Modal, Button, BUTTON_LAYOUTS } from 'components/UI'
import { Content, ContentText, ActionsWrapper } from 'themes/views/modals'
// constants
import { Modals } from 'constants/modals'
// themes
import { colors } from 'themes'
// utils
import { transparentize, ellipsis } from 'polished'

// styled
export const Header = styled(HeaderOrigin)`
  && {
    background: repeating-linear-gradient(
      135deg,
      ${transparentize(0.1, colors.red300)},
      ${transparentize(0.1, colors.red300)} 40px,
      ${colors.red300} 40px,
      ${colors.red300} 80px
    );

    ${ellipsis('100%')};
  }
`

interface Props {
  header?: React.ReactNode
  children?: React.ReactNode
  modalType?: Modals
}

const textStyle = { fontWeight: 500 }

const ConfirmDeleteModal: React.FC<Props> = ({ header, modalType, children }) => {
  const [isLoading, setLoading] = React.useState(false)

  const {
    hideModal,
    modalData: { handleConfirm, isOpen, name, text, width }
  } = useModalData({ modalType: modalType || Modals.CONFIRM_DELETE_MODAL })

  const handleConfirmClick = async (...args: any): Promise<void> => {
    try {
      setLoading(true)
      await handleConfirm(...args)
      hideModal()
    } catch (errors) {
      console.log('[ConfirmDeleteModal.handleConfirmClick]: ', errors)
    } finally {
      setLoading(false)
    }
  }

  if (!isOpen) {
    return null
  }

  return (
    <Modal hideModal={hideModal} isOpen={isOpen} width={width}>
      <Header>{header || name}</Header>
      <Content>
        <ContentText color={'inherit'} style={textStyle}>
          {children || text}
        </ContentText>
      </Content>
      <ActionsWrapper>
        <Button shadowLess isLoading={isLoading} layout={BUTTON_LAYOUTS.RED} onClick={handleConfirmClick}>
          Confirm
        </Button>
        <Button shadowLess layout={BUTTON_LAYOUTS.RED_INVERTED} onClick={hideModal}>
          Cancel
        </Button>
      </ActionsWrapper>
    </Modal>
  )
}

export default ConfirmDeleteModal
